module.exports = __webpack_public_path__ + "media/public/images/slider/banner_desktop-fc62b5de19a5775d5a8962a57fddb791.png";